module.exports = __webpack_public_path__ + "media/pong-hit.6ab0f413.mp3";